import React from 'react';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import IconButton from '../IconButton/IconButton';

import { handleExportAsCSV } from '@clatter/platform';
import { buttonWidths } from '../../config/consts';

const DataGridExportButton = ({ exportFileName, onExport, getExportOptions, customTooltip = 'Export' }) => {
  const apiRef = useGridApiContext();

  const handleClick = () => {
    if (onExport && typeof onExport === 'function') {
      return onExport(apiRef);
    }

    const options = getExportOptions ? getExportOptions(apiRef) : { utf8WithBom: true };

    handleExportAsCSV({
      options: options,
      apiRef: apiRef,
      exportedFileName: exportFileName,
    });
  };

  return (
    <IconButton onClick={handleClick} width={buttonWidths.md} tooltip={customTooltip}>
      <CloudDownloadIcon />
    </IconButton>
  );
};

export default DataGridExportButton;
